import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { later } from '@ember/runloop';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

interface Args {
	onClose: () => void;
}

export default class AppNotificationsInactiveUserComponent extends Component<Args> {
	@service('request') declare requestService: Service.Request;
	@service declare infolayer: Service.Infolayer;
	@service('model-manager/users') declare mmUsersService: Service.ModelManager.Users;

	get user() {
		return this.mmUsersService.inactiveInvitedUserRecordsForBanner[0]; // oldest
	}

	@action
	sendReminder(e: MouseEvent): void {
		const userId = this.user?.id;
		if (userId) {
			this.mmUsersService.sendUserInviteReminder(userId);
		}
		e.preventDefault();
	}

	@action
	close(): void {
		later(() => {
			this.args.onClose();
		}, 1000);
	}
	<template>
		<div class="notification-container inactive-user-notification">
			<div class="container">
				<a role="button" class="close" {{on "click" this.close}}>
					<CommonUiIconComponent @name="Close" @size="sm" />
				</a>
				<p>
					<CommonUiIconComponent @name="InfoFill" @size="sm" />
					<strong>
						{{this.user.email}}
						hasn’t accepted your invitation to join your team yet.
					</strong>
					Would you like to send them a reminder?
				</p>
				<a {{on "click" this.sendReminder}}>Send reminder</a>
			</div>
		</div>
	</template>
}
